import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMesh = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 23,
	viewBox: "0 0 26 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.49805 3.1C9.49805 4.2598 8.55733 5.2 7.39689 5.2C6.23644 5.2 5.29572 4.2598 5.29572 3.1C5.29572 1.9402 6.23644 1 7.39689 1C8.55733 1 9.49805 1.9402 9.49805 3.1Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.49805 3.1C9.49805 4.2598 8.55733 5.2 7.39689 5.2C6.23644 5.2 5.29572 4.2598 5.29572 3.1C5.29572 1.9402 6.23644 1 7.39689 1C8.55733 1 9.49805 1.9402 9.49805 3.1Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.7043 3.1C20.7043 4.2598 19.7636 5.2 18.6031 5.2C17.4427 5.2 16.5019 4.2598 16.5019 3.1C16.5019 1.9402 17.4427 1 18.6031 1C19.7636 1 20.7043 1.9402 20.7043 3.1Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.7043 3.1C20.7043 4.2598 19.7636 5.2 18.6031 5.2C17.4427 5.2 16.5019 4.2598 16.5019 3.1C16.5019 1.9402 17.4427 1 18.6031 1C19.7636 1 20.7043 1.9402 20.7043 3.1Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9027 8.7C17.9027 9.8598 16.962 10.8 15.8016 10.8C14.6411 10.8 13.7004 9.8598 13.7004 8.7C13.7004 7.5402 14.6411 6.6 15.8016 6.6C16.962 6.6 17.9027 7.5402 17.9027 8.7Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9027 8.7C17.9027 9.8598 16.962 10.8 15.8016 10.8C14.6411 10.8 13.7004 9.8598 13.7004 8.7C13.7004 7.5402 14.6411 6.6 15.8016 6.6C16.962 6.6 17.9027 7.5402 17.9027 8.7Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 11.5C25 12.6598 24.0593 13.6 22.8988 13.6C21.7384 13.6 20.7977 12.6598 20.7977 11.5C20.7977 10.3402 21.7384 9.4 22.8988 9.4C24.0593 9.4 25 10.3402 25 11.5Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 11.5C25 12.6598 24.0593 13.6 22.8988 13.6C21.7384 13.6 20.7977 12.6598 20.7977 11.5C20.7977 10.3402 21.7384 9.4 22.8988 9.4C24.0593 9.4 25 10.3402 25 11.5Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.7043 19.9C20.7043 21.0598 19.7636 22 18.6031 22C17.4427 22 16.5019 21.0598 16.5019 19.9C16.5019 18.7402 17.4427 17.8 18.6031 17.8C19.7636 17.8 20.7043 18.7402 20.7043 19.9Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.7043 19.9C20.7043 21.0598 19.7636 22 18.6031 22C17.4427 22 16.5019 21.0598 16.5019 19.9C16.5019 18.7402 17.4427 17.8 18.6031 17.8C19.7636 17.8 20.7043 18.7402 20.7043 19.9Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.49805 19.9C9.49805 21.0598 8.55733 22 7.39689 22C6.23644 22 5.29572 21.0598 5.29572 19.9C5.29572 18.7402 6.23644 17.8 7.39689 17.8C8.55733 17.8 9.49805 18.7402 9.49805 19.9Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.49805 19.9C9.49805 21.0598 8.55733 22 7.39689 22C6.23644 22 5.29572 21.0598 5.29572 19.9C5.29572 18.7402 6.23644 17.8 7.39689 17.8C8.55733 17.8 9.49805 18.7402 9.49805 19.9Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.20233 11.5C5.20233 12.6598 4.26161 13.6 3.10117 13.6C1.94072 13.6 1 12.6598 1 11.5C1 10.3402 1.94072 9.4 3.10117 9.4C4.26161 9.4 5.20233 10.3402 5.20233 11.5Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.20233 11.5C5.20233 12.6598 4.26161 13.6 3.10117 13.6C1.94072 13.6 1 12.6598 1 11.5C1 10.3402 1.94072 9.4 3.10117 9.4C4.26161 9.4 5.20233 10.3402 5.20233 11.5Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7004 14.3C13.7004 15.4598 12.7597 16.4 11.5992 16.4C10.4388 16.4 9.49805 15.4598 9.49805 14.3C9.49805 13.1402 10.4388 12.2 11.5992 12.2C12.7597 12.2 13.7004 13.1402 13.7004 14.3Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7004 14.3C13.7004 15.4598 12.7597 16.4 11.5992 16.4C10.4388 16.4 9.49805 15.4598 9.49805 14.3C9.49805 13.1402 10.4388 12.2 11.5992 12.2C12.7597 12.2 13.7004 13.1402 13.7004 14.3Z",
			fill: "var(--stroke-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.39689 19.9L11.5992 14.3M7.39689 19.9L3.10117 11.5M7.39689 19.9H18.6031M11.5992 14.3L15.8016 8.7M11.5992 14.3L7.39689 3.1M11.5992 14.3L22.8988 11.5M11.5992 14.3L18.6031 19.9M11.5992 14.3L3.10117 11.5M15.8016 8.7L18.6031 3.1M15.8016 8.7L7.39689 3.1M15.8016 8.7L22.8988 11.5M18.6031 3.1H7.39689M18.6031 3.1L22.8988 11.5M7.39689 3.1L3.10117 11.5M22.8988 11.5L18.6031 19.9M9.49805 3.1C9.49805 4.2598 8.55733 5.2 7.39689 5.2C6.23644 5.2 5.29572 4.2598 5.29572 3.1C5.29572 1.9402 6.23644 1 7.39689 1C8.55733 1 9.49805 1.9402 9.49805 3.1ZM20.7043 3.1C20.7043 4.2598 19.7636 5.2 18.6031 5.2C17.4427 5.2 16.5019 4.2598 16.5019 3.1C16.5019 1.9402 17.4427 1 18.6031 1C19.7636 1 20.7043 1.9402 20.7043 3.1ZM17.9027 8.7C17.9027 9.8598 16.962 10.8 15.8016 10.8C14.6411 10.8 13.7004 9.8598 13.7004 8.7C13.7004 7.5402 14.6411 6.6 15.8016 6.6C16.962 6.6 17.9027 7.5402 17.9027 8.7ZM25 11.5C25 12.6598 24.0593 13.6 22.8988 13.6C21.7384 13.6 20.7977 12.6598 20.7977 11.5C20.7977 10.3402 21.7384 9.4 22.8988 9.4C24.0593 9.4 25 10.3402 25 11.5ZM20.7043 19.9C20.7043 21.0598 19.7636 22 18.6031 22C17.4427 22 16.5019 21.0598 16.5019 19.9C16.5019 18.7402 17.4427 17.8 18.6031 17.8C19.7636 17.8 20.7043 18.7402 20.7043 19.9ZM9.49805 19.9C9.49805 21.0598 8.55733 22 7.39689 22C6.23644 22 5.29572 21.0598 5.29572 19.9C5.29572 18.7402 6.23644 17.8 7.39689 17.8C8.55733 17.8 9.49805 18.7402 9.49805 19.9ZM5.20233 11.5C5.20233 12.6598 4.26161 13.6 3.10117 13.6C1.94072 13.6 1 12.6598 1 11.5C1 10.3402 1.94072 9.4 3.10117 9.4C4.26161 9.4 5.20233 10.3402 5.20233 11.5ZM13.7004 14.3C13.7004 15.4598 12.7597 16.4 11.5992 16.4C10.4388 16.4 9.49805 15.4598 9.49805 14.3C9.49805 13.1402 10.4388 12.2 11.5992 12.2C12.7597 12.2 13.7004 13.1402 13.7004 14.3Z",
			stroke: "var(--stroke-color)"
		})
	]
});
export default SvgMesh;
